export async function getProductsByLocationRelocationsUseCase(locationId, relocationRepository) {
    const result = await relocationRepository.get_products_by_location(locationId);

    const valid = new relocationRepository.model_products(result.data);
    
    if (!valid.isValid()) {
        throw new Error("Reubicación inválida");
    }
    
    return result.data.data;
}